import { render, staticRenderFns } from "./LbPersonalPlanForm.vue?vue&type=template&id=62ebb020&"
import script from "./LbPersonalPlanForm.vue?vue&type=script&lang=js&"
export * from "./LbPersonalPlanForm.vue?vue&type=script&lang=js&"
import style0 from "./LbPersonalPlanForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports